import request from 'assets/js/http';

// 项目公司-详情页
export function saveProject(data) {
  let url = 'company/edit';
  return request({
    url,
    method: 'post',
    data
  });
}
// 项目详情-项目详情-工作进展-评论列表
export function getComment(entityId) {
  return request({
    url: '/comment/list',
    method: 'post',
    data: { entityId }
  });
}
// 项目详情-项目详情-工作进展-评论删除
export function delComment(commentId) {
  return request({
    url: '/comment/delete',
    method: 'post',
    data: { commentId }
  });
}
// 项目详情-项目详情-工作进展-评论新增
export function addComment(data) {
  return request({
    url: '/comment/add',
    method: 'post',
    data
  });
}
// 项目详情-项目详情-工作进展列表
export function getCompanyNotes(data) {
  return request({
    url: '/companyNotes/list',
    method: 'post',
    data
  });
}
// 项目详情-项目详情-工作进展详情
export function getCompanyNoteDetail(data, errorToast = true) {
  return request({
    url: '/companyNotes/detail',
    method: 'post',
    data,
    errorToast
  });
}
// 项目详情-项目详情-工作进展修改
export function editCompanyNotes(data) {
  return request({
    url: '/companyNotes/edit',
    method: 'post',
    data
  });
}
// 项目详情-项目详情-工作进展删除
export function deleteCompanyNotes(workProgressId) {
  return request({
    url: '/companyNotes/delete',
    method: 'post',
    data: { workProgressId }
  });
}
// 项目详情-项目详情-工作进展添加
export function addCompanyNotes(data) {
  return request({
    url: '/companyNotes/add',
    method: 'post',
    data
  });
}
// 项目详情-项目管理-修改标签
export function changeTagIds(data) {
  return request({
    url: '/company/changeTagIds',
    method: 'post',
    data
  });
}
// 第三方提供的竞品信息
export function competitor(data) {
  return request({
    url: '/thirdsource/competitor',
    method: 'post',
    data
  });
}
// 第三方提供的融资信息
export function financing(data) {
  return request({
    url: '/thirdsource/financing',
    method: 'post',
    data
  });
}
// 观察仓新闻动态
export function news(data) {
  return request({
    url: '/thirdsource/news',
    method: 'post',
    data
  });
}
// 搜索第三方数据库关联目标公司
export function search(keyword) {
  return request({
    url: '/thirdsource/search',
    method: 'post',
    data: { keyword }
  });
}

// 解绑第三方数据库目标公司
export function unbind(companyId) {
  return request({
    url: '/thirdsource/unbind',
    method: 'post',
    data: { companyId }
  });
}

// 业务推进总览
export function projectOverview(data) {
  return request({
    url: '/dashboard/projectOverview',
    method: 'post',
    data
  });
}
// 业务推进细节
export function projectDetail(data) {
  return request({
    url: '/dashboard/projectDetail',
    method: 'post',
    data
  });
}

// 获取选定stage下的成员list
export function stageMemberList(data) {
  return request({
    url: '/dashboard/stageMemberList',
    method: 'post',
    data
  });
}
